import React from "react";
import { connect } from "react-redux";

const UnconnectedReadyModal = (props) => (
    <div className="modal is-active" onClick={props.onClick}>
        <div className="modal-background"></div>
        <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title">Couchpile Player</p>
                <button className="delete" aria-label="close"></button>
            </header>
            <section className="modal-card-body">
                <p>{modalMessage(props.view_mode)}</p>
            </section>
            <footer className="modal-card-foot" style={{ justifyContent: "flex-end" }}>
                <button  onClick={props.onClick} className="button is-primary">Let&apos;s Watch</button>
            </footer>
        </div>
        <button className="modal-close is-large" aria-label="close"></button>
    </div>
);

function modalMessage(view_mode) {
    switch (view_mode) {
        case "full":
        case "video":
            return "Video playback will now be synced among everyone here. You can also open this page on your phone to use the chat by itself in a second screen, if you'd like.";
        case "chat":
            return "Hopefully you've also joined this room from your laptop, desktop, or projector, which is now showing the video. You can use this second screen to participate in the chat. Use the toolbar to change modes if you prefer.";
        default:
            return "";    
    }
}

const mapStateToProps = state => ({ view_mode: state.user.view_mode });
export const ReadyModal = connect(mapStateToProps,  { })(UnconnectedReadyModal);

